<style lang="scss">


</style>

<template>
  <div class="focused-panel">
    <div class="d-flex centreline-toolbar">
      <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create Capture Point"
             :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select Point"
             :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Multi Select"
             :pressed.sync="multiEdit" variant="primary">
        <icon scale=".6" name="dice-two"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges"
             @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit geometry"
             :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled" variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes"
             :disabled="!wellFeatureSelected" :pressed.sync="editEnabled" variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto
             title="Delete Capture Point" :disabled="!wellFeatureSelected" variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto
             title="Load dependant layers" variant="primary">
        <icon scale=".6" name="link"/>
      </b-btn>
    </div>

    <b-modal v-model="showForm" size="lg" no-close-on-backdrop no-close-on-esc id='capture-point-editor-modal'>
      <div slot="modal-header">
        <label>{{ formTitle }}</label>

      </div>

      <div class="p-2 pl-4">
        <b-form>
          <b-row>

            <b-col>
              <b-form-group label="Point Type:" label-for="etype">
                <b-form-select :options="etypes" id="etype"  v-model="wellAttrs['etype']"
                               placeholder="Please, select point type"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>

              <b-col>
                <b-form-group label="Comment:" label-for="description">
                  <b-textarea id="description" v-model="wellAttrs['description']" rows="3"></b-textarea>
                </b-form-group>
              </b-col>

          </b-row>

        </b-form>
      </div>
      <div slot="modal-footer" class="designatron-modal-footer w-100">
        <div role="group" class="btn-group">
          <b-btn size="sm"  variant="primary" @click="close" style="min-width:80px">
            Close
          </b-btn>
          <b-btn size="sm"  variant="success"
                 @click="onOK" style="min-width:80px">
            Save
          </b-btn>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
import 'vue-awesome/icons/list-ol'
import 'vue-awesome/icons/cut'
import 'vue-awesome/icons/compress'
import 'vue-awesome/icons/hand-pointer'
import 'vue-awesome/icons/undo'
import 'vue-awesome/icons/exchange-alt'
import 'vue-awesome/icons/bezier-curve'
import 'vue-awesome/icons/pencil-alt'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/clock'
import 'vue-awesome/icons/backward'
import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/unlock'
import 'vue-awesome/icons/dice-two'
import Feature from 'ol/Feature'
import uuidV1 from 'uuid/v1'
import Vue from 'vue'
import {parallel} from 'async'

export default {
  name: 'field-capture-point-editor',

  components: {},
  mixins: [FeatureEditorMixin],
  data() {
    return {
      idName: 'objectid',
      etypes: [
        'Point: Artesian bore',
        'Point: Bench mark',
        'Point: Boom gate',
        'Point: Boundary of Interest site eg. cultural heritage',
        'Point: Bridge abutment /Pier headstock top',
        'Point: Bridge abutment/ Pier column centreline',
        'Point: Bridge abutment/ Pier pile centreline',
        'Point: Bridge rail post',
        'Point: Bridge scuppers',
        'Point: Cadastral reference mark',
        'Point: Cadastral survey mark',
        'Point: Camera fixed - traffic lights/security',
        'Point: Carriageway - Material edge',
        'Point: Cellular telephone transponder',
        'Point: Chainage peg',
        'Point: Concrete barrier - Top (mid)',
        'Point: Edge of concrete - unspecified',
        'Point: Edge of stone pitching',
        'Point: Elevated joint - Telecommunications',
        'Point: Environment - Grass coverage',
        'Point: Fire hydrant',
        'Point: Fixed survey control - for traverse adjustment',
        'Point: Gate (stretched)',
        'Point: Ground control point - Photogrammetric',
        'Point: Gully pit',
        'Point: Inspection box /pit - Electricity',
        'Point: Inspection box /pit - Gas',
        'Point: Inspection box /pit - Main Roads',
        'Point: Inspection box /pit - Mains Water',
        'Point: Inspection box /pit - Optical Fibre',
        'Point: Inspection box /pit - Sewer',
        'Point: Inspection box /pit - Telecommunications',
        'Point: Inspection box /pit - Unspecified',
        'Point: Inspection box/pit - Traffic Control cabling',
        'Point: Instrument Station - Other mark',
        'Point: Instrument station - Primary mark',
        'Point: Invert level',
        'Point: Kerb - top',
        'Point: Letter box',
        'Point: Manhole - Gas',
        'Point: Manhole - Mains Water',
        'Point: Manhole - Optical Fibre',
        'Point: Manhole - Sewer',
        'Point: Manhole - Stormwater',
        'Point: Manhole - Telecommunications',
        'Point: Manhole - Unspecified',
        'Point: Marker post - Gas',
        'Point: Marker post - Mains Water',
        'Point: Marker post - Optical Fibre',
        'Point: Marker post - Sewer',
        'Point: Marker post - Unspecified',
        'Point: Materials bore /Pothole',
        'Point: Noise barrier - top',
        'Point: Non-standard feature string',
        'Point: Offset /Recovery mark',
        'Point: Optical fibre - underground',
        'Point: Permanent mark',
        'Point: Permanent reference point - RPC',
        'Point: Power line - Poles located',
        'Point: Power line no poles - wires only',
        'Point: Railway line - Top of rail',
        'Point: Railway mast ORG-ARW-GIS-STA-00013',
        'Point: Railway track - centreline',
        'Point: RIM - Telecommunications',
        'Point: Safety Fence - Thrie beam',
        'Point: Safety Fence - W beam',
        'Point: Safety Fence - Wire rope',
        'Point: Shrub',
        'Point: Soil - Change of type',
        'Point: Stream bed cross-section',
        'Point: Street light with mast arm (two points)',
        'Point: Sub-soil Inlet - Drain',
        'Point: Sub-soil Outlet - Drain',
        'Point: Telecommunications distribution pillar',
        'Point: Telecommunications underground',
        'Point: Tower - Electricity',
        'Point: Traffic controller box',
        'Point: Traffic sign - single',
        'Point: Traffic signal',
        'Point: Tree trunk - one size',
        'Point: Underground electricity',
        'Point: Underground oil line',
        'Point: Unspecified Valve',
        'Point: Valve - Gas',
        'Point: Valve - Sewer',
        'Point: Valve - Water',
        'Point: Water Tap',
      ],
      wellAttrs: {
        etype: null,
        description: ''
      },
      geomType: 'Point',
      wellLayerName: 'fr:field_capture_point',
      multiEdit: false,
    }
  },
  created() {
    this.selectTool = null
  },

  methods: {
    validateIdent() {
      this.identState = true
    },
    close(evt) {
      this.wellFeature = null
      this.showForm = false
      this.onCancel()
    }
  },
  watch: {},
}
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/FieldCapturePointEditor.vue